/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-03-13 20:01:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-18 17:54:34
 * @FilePath: /code/zeelool-nextjs/src/api/account.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { httpRequest } from '@/utils/axios';
import { getStableClientCyyInfo } from '@/utils/currency/client-currency';
import { ensureTongDunLoaded, getTongDunBlackBox } from '@/utils/tongdunScript';
import { CustomerOrderParams, CustomerWishParams } from './types/account';
import { Address } from './types/public';

export const getInviteData = () => httpRequest('GET:/api/customer/invite_register');
// 邀请记录列表
export const getInviteHistory = (params: { page: number; limit: number }) =>
  httpRequest('GET:/api/customer/exponent_invite_log', { params });

// 标记用户已经读了某一类型的消息
// 已读的消息通知类型: inviter:邀请人得积分; invitee_reg:被邀请人注册验证得积分;invitee_pay:被邀请人下单得积分;
export const clearInviteNotify = (params: { type: 'inviter' | 'invitee_reg' | 'invitee_pay' }) =>
  httpRequest('GET:/api/customer/clear_invite_notify', { params });
// 发送邀请好友邮件
export const sendInviteEmail = (params: { email: string }) =>
  httpRequest('GET:/api/customer/invite_send_email', { params }, { success: true, fail: false });
// 点击分享计数
export const clickShareCount = () => httpRequest('GET:/api/customer/invite_share_count');

export const fetchCustomerAccount = () =>
  httpRequest('GET:/api/customer/account', undefined, { success: false, fail: true });

export const fetchCustomerOrder = (
  params: CustomerOrderParams = {
    page: 1,
    limit: 20,
  },
) =>
  httpRequest('GET:/api/order/lists', {
    params,
  });

export const fetchRecommendProducts = (group_id: number) =>
  httpRequest('GET:/api/public/recommend_products', {
    params: {
      group_id,
      ...getStableClientCyyInfo(),
    },
  });

export const getMemberLevel = () => httpRequest('GET:/api/customer/member/levels');
export const fetchCustomerWish = (
  params: CustomerWishParams = {
    page: 1,
    limit: 30,
  },
) =>
  httpRequest('GET:/api/customer/wish', {
    params,
  });

export const fetchCustomerPointTask = () => httpRequest('GET:/api/customer/point_task');

export const fetchCustomerAddress = () => httpRequest('GET:/api/customer/address');

export const fetchCustomerPrescription = (params: any) =>
  httpRequest('GET:/api/customer/prescription', { params });

export const fetchCustomerQuestionList = () =>
  httpRequest('GET:/api/customer/get_customer_survey_list');

export const getSurveyPop = () =>
  httpRequest('GET:/api/customer/get_survey_pop', undefined, { success: false, fail: false });

export const fetchCustomerCouponList = () => httpRequest('GET:/api/customer/get_customer_coupon');

export const postJoinMember = (data) => httpRequest('POST:/api/customer/member/join', data);

// 问卷星问卷地址
export const fetchQuestionAddress = (params: { third_id?: string }) =>
  httpRequest('POST:/api/customer/start_answering_questions', {
    data: params,
  });

// 问卷星问卷提交
export const submitQuestion = (params: { third_id: string; status: number }) =>
  httpRequest('POST:/api/customer/submit_questionnaire', { data: params });

// 地址列表
export const fetchAddressList = () => httpRequest('GET:/api/customer/address');
// 设置默认地址
export const fetchSetDefaultAddress = (address_id: number) =>
  httpRequest(
    'PUT:/api/customer/default_address/{address_id}',
    { address_id },
    { success: true, fail: true },
  );
// 删除地址
export const fetchDeleteAddress = (address_id: number) =>
  httpRequest(
    'DELETE:/api/customer/address/{address_id}',
    { address_id },
    { success: true, fail: true },
  );
// 修改地址
export const fetchUpdateAddress = (address_id: number, data: Address, success = true) =>
  httpRequest(
    'PUT:/api/customer/address/{address_id}',
    {
      address_id,
      data: {
        ...data,
        province_id: data.province_id ? String(data.province_id) : undefined,
      },
    },
    { success, fail: true },
  );

// 添加地址
export const fetchAddAddress = (data: Address, success = true) =>
  httpRequest(
    'POST:/api/customer/address',
    {
      data: {
        ...data,
        province_id: data.province_id ? String(data.province_id) : undefined,
      },
    },
    { success, fail: true },
  );

// 获取用户处方
export const userPresList = (params: any) =>
  httpRequest('GET:/api/customer/prescription', { params });

// 上传用户处方
export const addUserPres = (data: any) =>
  httpRequest('POST:/api/customer/prescription', { data }, { success: false, fail: false });

// 删除用户处方
export const delUserPres = (id: string | number) =>
  httpRequest(
    'DELETE:/api/customer/prescription/{prescription_id}',
    { prescription_id: String(id) },
    { success: false, fail: false },
  );

// 更新用户处方
export const updateUserPres = (id: string | number, data: any) =>
  httpRequest(
    'PUT:/api/customer/prescription/{prescription_id}',
    { prescription_id: String(id), data },
    { success: false, fail: false },
  );

// 客服咨询列表
export const getWorkOrderList = (params: { page: number; limit: number }) =>
  httpRequest('GET:/api/customer/tickets_zendesk', { params });
// 修改用户信息
export const editAccountInfo = (data: any) => httpRequest('PUT:/api/customer/account', { data });

// 邮箱验证发送
export const sendEmail = () => httpRequest('POST:/api/customer/email/send');

// 发送修改邮箱验证码
export const sendEmailCode = (data: { email: string; sign: string }) =>
  httpRequest('POST:/api/customer/change_email_send_verify', { data });

// 验证用户邮箱
export const verifyCustomerEmail = (data: any) =>
  httpRequest('POST:/api/customer/email/verify', { data });

// 修改用户邮箱
export const changeCustomerEmail = (data: { code: string; email: string; sign: string }) =>
  httpRequest('POST:/api/customer/change_email', { data }, { success: true, fail: false });

// 手机验证码发送
export const sendTelephoneCode = (data: any) =>
  httpRequest('POST:/api/customer/telephone/send', { data }, { success: false, fail: true });

// 验证用户手机号
export const verifyCustomerTelephone = (data: any) =>
  httpRequest('POST:/api/customer/telephone/verify', { data }, { success: true, fail: false });

// 信息完善角标数据记录
// TODO: 有啥用？？
// 类型 1：侧边角标 2 我的角标
export const setClickRecord = (data) =>
  httpRequest(`POST:/api/customer/click_record`, { data }, { success: false, fail: false });

export const fetchGetRecentlyViewedList = (params: {
  limit?: number;
  page?: number;
  filter?: Record<string, any>;
}) => httpRequest(`GET:/api/customer/read_log_list`, { params });

export const fetchDeleteRecentlyViewedLog = (data: { id?: number[] }) =>
  httpRequest('DELETE:/api/customer/del_read_log', { data }, { success: true, fail: true });

// 验证密码接口(目前用于修改邮箱前的账户验证)
export const verifyCustomerPwd = (data: any) =>
  httpRequest('POST:/api/customer/check_password', { data }, { success: false, fail: false });

// 钱包日志
export const fetchWalletLog = (params: { page: number; limit: number; currency: string }) =>
  httpRequest('GET:/api/customer/wallet_log', { params });

// 获取兑换历史
export const fetchRedeemedHistory = () => httpRequest('POST:/api/customer/coupon_history');

// 获取兑换信息
export const fetchRedeemableFreeData = () => httpRequest('GET:/api/customer/discount_code/free');

// 获取兑换商品列表
export const fetchRedeemableList = (params: { page: number; limit: number }) =>
  httpRequest('GET:/api/products/member_products', { params });

// 获取兑换专区规则
export const fetchExchangeExplain = () =>
  httpRequest('GET:/api/products/change_coupon_products/explain');

// 兑换商品
export const fetchRedeemableItem = (data: {
  cart_id?: number;
  product_id?: number;
  coupon_id?: number;
}) => httpRequest('POST:/api/cart/coupon', { data });

// 获取会员规则
export const fetchMemberRules = () => httpRequest('GET:/api/customer/member/privileges/new');

export const fetchMemberPrivileges = () => httpRequest('GET:/api/customer/member/privileges/v3');

// 退出会员
export const fetchExitMember = () => httpRequest('POST:/api/customer/member/quit');

// 退订邮件
export const unsubscribeEmail = () => httpRequest('POST:/api/customer/unsubscribe_email');

// 删除账户相关接口
// 检测用户是否可以删除账户
export const logOffCheck = () => httpRequest('POST:/api/customer/log_off_check');

// 发送删除账户验证码
export const logOffSendCode = (data: { reason: string }) =>
  httpRequest('POST:/api/customer/log_off_send_code', { data });

// 删除账户
export const logOff = (data: { code: string; reason: string }) =>
  httpRequest('POST:/api/customer/log_off', { data });

// 获取积分商城信息
export const fetchPointsMallInfo = () => httpRequest('GET:/api/customer/points/mall');

// 获取积分历史
export const fetchPointsHistory = (params: {
  way?: number;
  type?: number;
  content?: string;
  limit?: number;
  page?: number;
}) => httpRequest('GET:/api/customer/point', { params });

// 获取积分商城商品列表
export const fetchPointsMallProducts = (params: {
  page: string;
  limit: string;
  'filter[point_min]'?: string;
  'filter[point_max]'?: string;
  'filter[is_glass]'?: string;
  order?: string;
  currency: string;
}) => httpRequest('GET:/api/customer/points/products', { params });

// 获取积分商城优惠券列表
export const fetchPointsMallCouponList = (params: {
  page: number;
  limit: number;
  currency: string;
  order?: string;
}) => httpRequest('GET:/api/customer/points/coupons', { params });

// 获取积分商城所有商品
export const fetchPointsMallAllProducts = (params: {
  /** 排序: default,point_asc,point_desc; */
  order: string;
  /** 积分范围筛选 */
  'filter[point_min]'?: string;
  /** 积分范围筛选 */
  'filter[point_max]'?: string;
  /** 每页条数 */
  limit?: string;
  /** 页码 */
  page?: string;
}) => httpRequest('GET:/api/customer/points/all_products', { params });

// 获取积分商城商品详情
export const fetchPointsMallProductDetail = (shop_sku: string) =>
  httpRequest('GET:/api/customer/points/products/{shop_sku}', { shop_sku });

// 获取积分商城优惠券详情
export const fetchPointsMallCouponDetail = (discount_code_id: number) =>
  httpRequest('GET:/api/customer/points/coupons/{discount_code_id}', {
    discount_code_id,
  });

// 积分商城-积分优惠券兑换
export const redeemCoupon = (data: { discount_code_id: number }) =>
  httpRequest('POST:/api/customer/points/coupons', { data });

// 积分商城-积分规则
export const fetchPointsMallRules = () => httpRequest('GET:/api/public/point_rule');

// 登录注册相关API
export const checkEmailRegister = (data: { email: string }) =>
  httpRequest('POST:/api/auth/check_email_register', { data });

export const login = async (data: { email: string; password: string }) => {
  // 确保同盾脚本已加载（延迟加载，不影响 TBT）
  await ensureTongDunLoaded();
  return httpRequest('POST:/api/auth/login', {
    data: {
      ...data,
      black_box: getTongDunBlackBox(),
    },
  });
};

export const loginOut = () => httpRequest('POST:/api/customer/logout', undefined);

export const register = async (data: {
  email: string;
  password: string;
  country_id?: string;
  tel_code?: string;
  telephone?: string;
  birthday?: string;
  gender?: string;
  is_agreement?: number;
  utm_info?: Record<string, any>;
  register_path?: string;
}) => {
  // 确保同盾脚本已加载（延迟加载，不影响 TBT）
  await ensureTongDunLoaded();
  return httpRequest('POST:/api/auth/register', {
    data: {
      ...data,
      black_box: getTongDunBlackBox(),
    },
  });
};

export const fastRegister = async (data: {
  email: string;
  is_agreement?: number;
  utm_info?: Record<string, any>;
  register_path?: string;
}) => {
  // 确保同盾脚本已加载（延迟加载，不影响 TBT）
  await ensureTongDunLoaded();
  return httpRequest('POST:/api/auth/fast_register', {
    data: {
      ...data,
      black_box: getTongDunBlackBox(),
    },
  });
};

/** 合规：根据 global init 的 policies 批量上报用户已同意的协议（需已登录） */
export const updateComplianceConsents = (data: {
  scene_code: string;
  page?: string;
  items: Array<{
    consent_type: number;
    policy_id: string | number;
    policy_version: string | number;
    email?: string;
    tel_code?: string;
    telephone?: string;
  }>;
}) => httpRequest('POST:/api/compliance/consents', { data }, { success: false, fail: false });

/** 合规：查询当前登录用户营销同意状态（需已登录） */
export const fetchComplianceMarketingStatus = () => {
  return httpRequest('GET:/api/compliance/marketing_status', undefined, {
    success: false,
    fail: false,
  });
};

export const thirdLoginRedirect = async (data: {
  provider: string;
  redirect: string;
  event_type?: string;
}) => {
  // 确保同盾脚本已加载（延迟加载，不影响 TBT）
  await ensureTongDunLoaded();
  return httpRequest('GET:/api/auth/third_login_redirect', {
    params: {
      ...data,
      black_box: getTongDunBlackBox(),
    },
  } as any);
};

export const resetPasswordSendEmail = (data: { email: string }) =>
  httpRequest('POST:/api/auth/reset_password_send_email', { data });

export const resetPassword = (data: {
  email: string;
  password: string;
  confirm_password: string;
  code: string;
}) =>
  httpRequest('POST:/api/auth/reset_password', {
    data: {
      ...data,
      email: data.email as any, // 临时解决类型不匹配问题
    },
  });
// 用户来源
export const userSource = (data: any) =>
  httpRequest('POST:/api/public/user_source', { data }, { success: false, fail: false });

// 绑定 impact
export const bindImpact = (params: { irclickid?: string; impact_app_custom_profile_id?: string }) =>
  httpRequest('GET:/api/customer/bind_impact', { params }, { success: false, fail: false });

// 绑定 Awin
export const bindAwin = (params: { awc?: string }) =>
  httpRequest('GET:/api/customer/bind_awin', { params }, { success: false, fail: false });

// 绑定 Pepperjam
export const bindPepperjam = (params: {
  publisher_id: string;
  click_id: string;
  utm_campaign: string;
}) => httpRequest('GET:/api/customer/bind_pepperjam', { params }, { success: false, fail: false });

// reCAPTCHA 验证
export const reCAPTCHA = (data: any) =>
  httpRequest('GET:/tools/recaptcha/verify', { params: data });

export const getMarketingStatus = () =>
  httpRequest('GET:/api/compliance/marketing_status' as any, undefined, {
    success: false,
    fail: false,
  });
